import { memo, ReactNode } from 'react';

import { Text } from '@components/Text';

export const FieldLabel = memo<{ title: ReactNode; testId?: string }>(({ title, testId }) => {
  if (typeof title === 'string') {
    return (
      <Text $level={4} color="text-black" className="font-medium leading-5" id={testId ? `${testId}-label` : undefined}>
        {title}
      </Text>
    );
  }
  return <>{title}</>;
});

FieldLabel.displayName = 'FieldLabel';
